module.exports = __webpack_public_path__ + "img/icon_nuser.2f0d5f85.svg";